import { Modal } from 'antd';
import { useUser } from '@/biz/user.mjs';
import { isAdmins } from "@/script/admin.js";

const MESSAGE = '此功能仅平台管理员可用'

export const useCheckPlatformAdmin = () => {
    const isPlatformAdmin = useIsPlatformAdmin()

    return () => {
        if (!isPlatformAdmin) {
            Modal.error({ content: MESSAGE })
            throw new Error(MESSAGE)
        }
    }
}

export const useFilterByPlatformAdmin = () => {
    const isPlatformAdmin = useIsPlatformAdmin()
    return a => isPlatformAdmin ? a : null
}

export const useIsPlatformAdmin = () => {
    const user = useUser()
    return isAdmins(user);
}
